import AdminAlertPanel from "./AdminAlertPanel";

const adminalertpanel = (props: any) => {
  return <AdminAlertPanel {...props} />;
};

export const adminAlertComponents = {
  adminalertpanel,
};
